/**
 * Created by JackCui on 2021/12/1
 */
export const summarySchemaHandle = {
  // {fieldMap, mainField}
  handle ({name, apiName}, {fieldMap, mainField}) {
    return {
      props: {
        name
      },
      mainField,
      apiName
    }
  }
}

export const summaryProps = {}
